<template>
  <div class="activity">
    <van-dropdown-menu>
      <van-dropdown-item
        get-container="body"
        v-model="invest_request.orgId"
        :options="company"
        :title-class="'left-class'"
        @change="onRefresh(true)"
      />
      <van-dropdown-item
        get-container="body"
        v-model="invest_request.busiManageTypeCode"
        :options="type"
        :title-class="'right-class'"
        @change="onRefresh(true)"
      />
    </van-dropdown-menu>
    <div class="list">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
        >
          <listActivity
            v-for="(item, index) in records"
            :key="index"
            :record="item"
          ></listActivity>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Vue from "vue";
import { DropdownMenu, DropdownItem } from "vant";
import listActivity from "../components/listActivity";

Vue.use(DropdownMenu);
Vue.use(DropdownItem);
export default {
  name: "InvestmentActivity",
  components: {
    listActivity,
  },
  data() {
    return {
      
      company: [
        { text: "单位", value: "" }
      ],
      type: [
        { text: "活动类型", value: "" },
        { text: "赴外招商", value: "1" },
        { text: "客商来滇", value: "2" },
        { text: "会见客商", value: "3" },
        { text: "驻点招商", value: "4" },
        { text: "专项招商推介活动", value: "5" },
      ],
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      error_true: false,
      records: [],
      invest_request: {
        current: 0, //当前页
        size: 10, //每页条数
        orgId: "", //单位id
        busiManageTypeCode: "", //活动类型code
      },
    };
  },
  computed: {
    ...mapGetters('investment', ['getActivityOption'])

  },
  created() {
    this.setInvestmentTitle("招商活动列表");

    this.invest_request.orgId = this.getActivityOption.orgId
    this.invest_request.busiManageTypeCode = this.getActivityOption.busiManageTypeCode

    this.orgUnitList().then(res=>{
      res.forEach(element => {
        this.company.push({
          text: element.fullName,
          value: element.code
        })
      });
      
    })
  },
  watch: {},
  methods: {
    ...mapActions("investment", ["setInvestmentTitle", "getInvestList","orgUnitList","setActivityOption"]),
    onLoad() {
      console.log("加载下一页");
      if(!this.error_true){
          this.invest_request.current++
      }
      this.refresh();
    },
    //下拉刷新时触发
    onRefresh(value) {
      console.log("下拉刷新时触发");
      if(value){
        this.setActivityOption({
          orgId: this.invest_request.orgId,
          busiManageTypeCode: this.invest_request.busiManageTypeCode,
        })
      }
      this.invest_request.current = 1;
      this.records = [];
      this.refresh();
    },
    refresh() {
      this.getInvestList(this.invest_request)
        .then((res) => {
          this.refreshing = false;
          this.loading = false;
          this.error_true = false;
          if (res.invest.pages > this.invest_request.current) {
            this.finished = false;
          } else {
            this.finished = true;
          }
          res.data.forEach(element => {
            element.createTime = element.createTime? element.createTime.replace(/T/g,' ').replace(/Z/g,''):''
          });
          this.records = this.records.concat(res.data);
        })
        .catch((res) => {
          this.refreshing = false;
          this.loading = false;
          this.finished = false;
          this.error = true;
          this.error_true = true;
        });
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.activity {
  min-height: 100%;
  font-family: PingFangSC-Regular;
  background: #F5F6F9;
  .list {
    padding: 0 12px;
  }
  /deep/.van-dropdown-menu__bar {
    justify-content: flex-start;
  }
  /deep/.van-dropdown-menu__item {
    flex: none;
    margin-right: 20px;
  }
  /deep/.left-class {
    color: #333333;
    font-size: 14px;
    padding: 0 12px;
  }
  /deep/.right-class {
    color: #333333;
    font-size: 14px;
  }
}
</style>